import React, { useEffect, useState } from 'react';
import { getCashSessionSummary } from '../api/posApi';

const SessionSummary = ({ sessionId }) => {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!sessionId) return;
    let mounted = true;
    const loadSummary = async () => {
      setLoading(true);
      try {
        const data = await getCashSessionSummary(sessionId);
        if (mounted) {
          setSummary(data?.summary || data);
        }
      } catch (error) {
        if (mounted) {
          setSummary(null);
        }
      } finally {
        if (mounted) setLoading(false);
      }
    };
    loadSummary();
    return () => {
      mounted = false;
    };
  }, [sessionId]);

  return (
    <div className="card p-3 mt-3">
      <h5>Résumé de session</h5>
      {loading && <p className="text-muted">Chargement…</p>}
      {!loading && summary && (
        <>
          <div className="d-flex justify-content-between">
            <span>Total ventes</span>
            <span>{(summary.total_sales || 0).toFixed(2)} MAD</span>
          </div>
          <div className="d-flex justify-content-between">
            <span>Total retours</span>
            <span>{(summary.total_returns || summary.total_refunds || 0).toFixed(2)} MAD</span>
          </div>
          <div className="d-flex justify-content-between fw-bold mt-2">
            <span>Net</span>
            <span>{(summary.net_total || 0).toFixed(2)} MAD</span>
          </div>
        </>
      )}
      {!loading && !summary && <p className="text-muted">Aucun résumé disponible.</p>}
    </div>
  );
};

export default SessionSummary;
